import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    //  <React.StrictMode> API 테스트할때만 임시해제
    <App />
    // </React.StrictMode>
);
